export default __webpack_public_path__ + "static/media/103.222a575a.jpg";